module.exports = __webpack_public_path__ + "img/new_sdg.89b7479a.svg";